import React from 'react';
import cn from 'classnames';

import Section from 'react-scale/components/elements/section';
import { Grid, GridItem } from 'react-scale/components/website/big/main/Grid';

const BorderText = ({ title, content, border, borderColor }) => {
  const columns = border ? '2 / 11' : '3 / 11';
  return (
    <Section>
      <Grid margin={{ xl: 0, lg: 0, md: 0, xs: 0 }}>
        <GridItem xl={columns} lg={columns}>
          <div className={cn({ border })}>
            {title && <h2 className="text-xl">{title}</h2>}
            {content.map(paragraph => (
              <p className="text-lg" key={paragraph}>
                {paragraph}
              </p>
            ))}
            <style jsx>{`
              div.border {
                margin: 0 0 0 calc(var(--columns-size) - 2rem / 2);
                padding: 0 0 0 2rem;
                border: 0;
                border-left: calc(2rem / 2) solid ${borderColor};
              }
            `}</style>
          </div>
        </GridItem>
      </Grid>
    </Section>
  );
};

BorderText.defaultProps = {
  borderColor: '',
  border: true,
  title: null,
  bottom: false,
  top: false
};

export default BorderText;
